import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Lock } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { startGoogleLogin } from "./useOwnerAuth";
import { PasswordLoginForm } from "./PasswordLoginForm";

export const OwnerLoginScreen = ({ forbidden, path = "/dashboard", testId = "owner-login-screen" }) => {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div
      className="min-h-screen bg-[#0E1A2B] grain relative flex items-center justify-center px-4"
      data-testid={testId}
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-sm rounded-3xl bg-[#132338] border border-[#203859] p-8 text-center"
      >
        <img
          src="/logo.png"
          alt="PERETE Flooring and Carpet Installation Inc. logo"
          className="mx-auto h-20 w-20 rounded-full ring-2 ring-[#F26522]/70 object-cover"
        />
        <h1 className="mt-5 font-display text-2xl font-bold text-white">{t("dash_access")}</h1>
        <p className="mt-2 text-sm text-slate-400">
          {forbidden ? t("dash_forbidden") : t("dash_login_sub")}
        </p>
        <button
          onClick={() => startGoogleLogin(path)}
          className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#F26522] hover:bg-[#D85312] text-white font-display font-bold px-6 py-3.5 text-sm transition-[background-color,transform] duration-200 hover:scale-[1.02] active:scale-95"
          data-testid={testId === "owner-login-screen" ? "dashboard-google-signin-btn" : `${testId}-google-signin-btn`}
        >
          <Lock className="h-4 w-4" />
          {t("dash_signin")}
        </button>
        <PasswordLoginForm path={path} />
        <button
          onClick={() => navigate("/")}
          className="mt-4 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 hover:text-[#F26522] transition-colors duration-200"
          data-testid={testId === "owner-login-screen" ? "login-back-home-btn" : `${testId}-back-home-btn`}
        >
          <ArrowLeft className="h-3.5 w-3.5" /> {t("dash_back")}
        </button>
      </motion.div>
    </div>
  );
};
